<template>
  <v-row>
    <v-col cols="12">
      <gg-card>
        <gg-card-header>Add New User</gg-card-header>
        <gg-card-text>
          <create-user-form @user-created="reloadUsers"></create-user-form>
        </gg-card-text>
      </gg-card>
    </v-col>
    <v-col cols="12">
      <gg-card>
        <gg-card-header>
          <v-row>
            <v-col cols="12" md="6" class="pt-md-3">
              Manage Users
            </v-col>
            <v-col cols="12" md="6" class="font-weight-regular">
              <gg-text-field
                outlined
                v-model="searchUser"
                append-icon="mdi-magnify"
                placeholder="Search"
                single-line
                hide-details
              />
            </v-col>
          </v-row>
        </gg-card-header>
        <gg-card-text>
          <users-table :search="searchUser" :loading="loadingUsers" @table-action-completed="reloadUsers" />
        </gg-card-text>
      </gg-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions } from 'vuex'
import CreateUserForm from '@/components/Services/Hosting/Shared/Mysql/Users/CreateUserForm'
import UsersTable from '@/components/Services/Hosting/Shared/Mysql/Users/UsersTable'

export default {
  name: 'MySqlUsersView',
  components: {
    CreateUserForm,
    UsersTable
  },
  data () {
    return {
      loadingUsers: false,
      searchUser: ''
    }
  },
  methods: {
    ...mapActions({
      getMysqlRestrictions: 'mysql/getMysqlRestrictions',
      getMysqlUsers: 'mysql/getMysqlUsers',
      reportError: 'reportError'
    }),
    async reloadUsers () {
      this.loadingUsers = true
      try {
        await this.getMysqlUsers(this.$route.query.user)
      } catch (e) {
        this.reportError(e)
      }
      this.loadingUsers = false
    }
  },
  async created () {
    try {
      await this.getMysqlRestrictions(this.$route.query.user)
    } catch (e) {
      this.reportError(e)
    }
    this.reloadUsers()
  }
}
</script>
